
import { v4 as uuid } from 'uuid'

export class MCOption {
  id: number  
  name: string
  sort_order: number

  constructor() { 
  }

  static buildOne(obj: any): MCOption {
    let target: MCOption = Object.assign(new MCOption(), obj)
    return target
  }

  static buildMany(objs: any[]): MCOption[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(MCOption.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export class ShowIfQuestion {
  question_id: number  
  show_if_question_id: number
  show_if_data: string

  constructor() { 
  }

  static buildOne(obj: any): ShowIfQuestion {
    let target: ShowIfQuestion = Object.assign(new ShowIfQuestion(), obj)
    return target
  }

  static buildMany(objs: any[]): ShowIfQuestion[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(ShowIfQuestion.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export class Question {
  id: number  
  name: string
  sort_order: number
  data_type: string
  min: number
  max: number  
  is_required: boolean
  is_na_allowed: boolean
  is_na_selected: boolean
  is_visible: boolean
  options: MCOption[]  
  show_if_questions: ShowIfQuestion[]

  constructor() { 
  }

  static buildOne(obj: any): Question {
    let target: Question = Object.assign(new Question(), obj)
    return target
  }

  static buildMany(objs: any[]): Question[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(Question.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export class Project {
  uuid: string
  id: number  
  name: string
  sort_order: number
  store_ids: number[]
  questions: Question[]
  
  constructor() { 
  }

  static buildOne(obj: any): Project {
    let target: Project = Object.assign(new Project(), obj)  
    return target
  }

  static buildMany(objs: any[]): Project[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(Project.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

